module.exports = __webpack_public_path__ + "packs/media/images/stefanie_lopar_2-6ec69cc3d7bea3e3204310181341771f.jpg";